import React from "react";

const stylesByVariant = {
  default:
    "bg-blue-600 text-white hover:bg-blue-500 border border-blue-500/60 shadow-[0_10px_24px_rgba(37,99,235,0.35)]",
  outline:
    "bg-white/10 text-white border border-white/30 hover:bg-white/20 backdrop-blur-sm",
  ghost:
    "bg-transparent text-white border border-transparent hover:bg-white/15",
};

const stylesBySize = {
  default: "h-10 px-4 text-sm",
  sm: "h-9 px-3 text-xs",
  lg: "h-11 px-5 text-sm",
  icon: "h-10 w-10 p-0",
};

const Button = React.forwardRef(
  (
    {
      className = "",
      variant = "default",
      size = "default",
      type = "button",
      ...props
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        className={[
          "inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 disabled:pointer-events-none disabled:opacity-50",
          stylesByVariant[variant] || stylesByVariant.default,
          stylesBySize[size] || stylesBySize.default,
          className,
        ].join(" ")}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";

export { Button };
